window.pendo = require('./_pendo-script');